import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import withRouter, {routerPropTypes} from '~/router/withRouter';
import {Button} from '@customink/pigment-react';

const propTypes = {
  dismiss: PropTypes.func,
  exitWarningEligibility: PropTypes.func,
  proceedToDesign: PropTypes.func,
  router: routerPropTypes,
  onMounted: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
class LoadDesignWithDirtyDesignNotification extends Component {
  static propTypes = propTypes;

  static defaultProps = {
    dismiss() {},
    primaryAction() {},
    exitWarningEligibility() {}
  };

  componentDidMount() {
    this.updateExitWarningEligibility(false);
  }

  componentWillUnmount() {
    this.updateExitWarningEligibility();
  }

  cancel = () => {
    this.props.dismiss();
  };

  continue = () => {
    this.props.dismiss();
    this.props.proceedToDesign();
  };

  save = () => {
    this.props.dismiss();
    this.props.router.navigate('/next/saveForm?src=loadDesignSavePrompt');
  };

  updateExitWarningEligibility = (eligible = true) => {
    this.props.exitWarningEligibility(eligible);
  };

  render() {
    return (
      <Notification
        dismiss={this.cancel}
        title="You Have Unsaved Changes"
        type="ERROR">
        <p className="ndx-cta1">
          If you continue without saving, your
          <br />
          current design will be lost.
        </p>
        <Button
          size="large"
          variant="Primary"
          className="notification-cta"
          onClick={this.save}>
          Save My Design
        </Button>
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={this.continue}>
          Continue Without Saving
        </Button>
      </Notification>
    );
  }
}

LoadDesignWithDirtyDesignNotification.displayName =
  'LoadDesignWithDirtyDesignNotification';

export default withRouter(LoadDesignWithDirtyDesignNotification);
